import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import * as FileSaver from 'file-saver';
import {AuthService} from '../auth/auth.service';


@Injectable({
	providedIn: 'root'
})
export class SoftService {

	constructor(private http: HttpClient,
	            private authService: AuthService,
	            private router: Router) {
	}


	getSoftProductionList() {
		return this.http.get<any>('api/get_list_app');
	}


	getSoftProductionFile(app: string, id: string, param: string, rf: string) {
		this.http.post('api/soft_emb?app=' + app + '&id=' + id + '&param=' + param + '&rf=' + rf,
			null,
			{
				responseType: 'arraybuffer',
				headers: {'Content-Type': 'application/x-www-form-urlencoded'},
				observe: 'response'
			})
			.subscribe((response) =>
					this.downLoadFile(response.headers.get('content-disposition'), response.body, response.headers.get('content-type'))
				, err => {
					if (err.status === 403) {
						this.authService.logout();
						this.router.navigate(['login']);
					}
				});
	}

	downLoadFile(headers: string, data: any, type: string) {
		if (headers.startsWith('filename=')) {
			const reportName = headers.split('=')[1];
			const blob = new Blob([data], {type: type});
			const file = new File([blob], reportName,
				{type: type});
			FileSaver.saveAs(file);
		}
	}

}
